// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"420":"1d479c2439bb4d1ab91f","851":"8a51d231f0c28e672655"}[chunkId] + ".css";
};